import { gql } from '@apollo/client';

export const CREATE_LXP_FILE = gql`
    mutation createLxpFile( $input: CreateLxpFileInput! ){
        result: createLxpFile(input: $input) {
            id
            name
            filename
            signedUrl
        }
    }
`;
